import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import CourseCard from '../../course-card/course-card';
import CollectionCard from '../../collection-card/collection-card';
import AssessmentCard from '../../assessment-card/assessment-card';
import ResourceCard from '../../resource-card/resource-card';
import QuestionCard from '../../question-card/question-card';
import CatalogPullOut from '../../catalog-pull-out/catalog-pull-out';
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue';
import { copy, activeTab } from '@/utils/utils';
import PartnerCard from '@/components/libraries-card/partner-card/partner-card';
import { LibrariesModel } from '@/models/libraries/libraries';
import { CATALOG_MENUS, LEARNING_MAP_CONTENT_SEQUENCE, LIBRARY_SCOPEKEYS } from '@/utils/constants';
import OfflineActivityCard from '../../offline-activity-card/offline-activity-card';
import { sessionService } from '@/providers/services/auth/session';

@Component({
    name: 'activity-content',
    components: {
        'material-icon': GoogleMaterialIcon,
        'course': CourseCard,
        'collection': CollectionCard,
        'assessment': AssessmentCard,
        'resource': ResourceCard,
        'question': QuestionCard,
        'catalog-pull-out': CatalogPullOut,
        'scale-loader': ScaleLoader,
        'partnerContent': PartnerCard,
        'offlineActivity': OfflineActivityCard,
        'player-pullup': () => import('@/components/cards/player-pullup/player-pullup.vue'),
    },
})

export default class ActivityContent extends Vue {

    private get session() {
        return sessionService.getSession();
    }

    private get params() {
        return Object.assign( {} , this.defaultparam, this.filterParams);
    }

    private get contents() {
        return this.$store.state.activityStore[`${this.activeComponent.key}Catalog`].searchResults || [];
    }

    private get isMyContent() {
        const scopeKey = this.filterParams!.scopeKey;
        const isMyContent = scopeKey ? scopeKey === LIBRARY_SCOPEKEYS.myContent : false;
        return  this.session!.isShareableLink ? false : isMyContent;
    }

    private get isCapLibray() {
        return this.$access.isCapLibrary;
    }

    public static previousTab: number = 1;
    // --------------------------------------------------------------------
    // Properties
    @Prop()
    private activeComponent: any;

    @Prop()
    private catalogMenus: any;

    @Prop()
    private filterParams: any;

    private pageContents: any = [];

    private isLoaded: boolean = false;

    private collectionData: any = null;

    private subFilter: any = null;

    private libraryFilter: any = null;

    private activeLibrary: any = null;

    private ownerFilter: any = [];

    private isOwnerFilter: boolean = false;

    private activeOwner: any = null;

    private defaultparam: any = {
        start: 1,
        length: 10,
    };

    private isPlayer: boolean = false;

    private playerURL: string = '';

    private isLoading: boolean = false;

    public beforeDestroy() {
        this.$root.$off('evenBusCatalogSubFlt');
    }

    @Watch('filterParams', {deep: true})
    private onChangeParams(value: any) {
        this.isLoading = true;
        if (value!.scopeKey  !== LIBRARY_SCOPEKEYS.libraries) {
            this.activeLibrary = null;
        }
        this.pageContents = [];
        this.defaultparam.start = 1;
        this.onLoadData();

    }

    @Watch('activeComponent', {deep: true})
    private onChangeActiveComponent(value: any) {
        if (!this.isLoading) {
            if (value.key === 'partnerContent') {
                this.activeLibrary = null;
            }
            this.isOwnerFilter = false;
            this.activeOwner = null;
            this.pageContents = [];
            this.subFilter = null;
            this.defaultparam.start = 1;
            this.onLoadData();
        }
    }
    // -------------------------------------------------------------------------------
    // Hooks
    private created() {
        this.pageContents = [];
        this.defaultparam.start = 1;
        this.onLoadData();
        this.$root.$on('evenBusCatalogSubFlt', (params: any) => {
            this.pageContents = [];
            this.subFilter = params;
            this.onLoadData();
        });
    }

    // ----------------------------------------------------------------------
    // Actions

    private openPullout(content: any) {
        this.collectionData = content;
        (this.$el.querySelector('.catalog-pull-out-container') as HTMLElement).style.left = 'calc(100vw - 450px)';
    }

    private partnerContent(library: LibrariesModel | any) {
        const activePage = { pageIndex: 1, count: 0 };
        CATALOG_MENUS.forEach((content, index) => {
            const type = content.key;
            if (library.hasOwnProperty(`${type}Count`)) {
                if (library[`${type}Count`] > activePage.count) {
                    activePage.count = library[`${type}Count`];
                    activePage.pageIndex = index;
                }
            }
        });
        this.activeLibrary = library;
        const hasSearchTerms = this.filterParams.q !== '*';
        this.libraryFilter = {scopeTargetNames: library.shortName};
        const activeTabs = this.catalogMenus.find((item: any) => item.isActive);
        this.$set(activeTabs, 'isActive', false);
        activePage.pageIndex = hasSearchTerms ? ActivityContent.previousTab : activePage.pageIndex;
        if (!activeTabs.isActive) {
            this.$set(this.catalogMenus[2], 'isActive', true);
        }
        if (this.$access.isCapLibrary) {
            this.$emit('onSelectTenantCard');
        }
        window.scrollTo(0, 0);
    }

    private backtoLibraries() {
        this.activeLibrary = null;
        const libraryMenu = activeTab(this.catalogMenus, 'partnerContent');
        const activeTabs = this.catalogMenus.find((item: any) => item.isActive);
        this.$set(activeTabs, 'isActive', false);
        if (!activeTabs.isActive) {
            this.$set(libraryMenu, 'isActive', true);
        }
    }

    private filterOwner(creator: any) {
        this.activeOwner = creator;
        this.pageContents = [];
        this.isOwnerFilter = true;
        this.defaultparam.start = 1;
        this.onLoadData();
    }

    private clearOwner() {
        this.isOwnerFilter = false;
        this.pageContents = [];
        this.activeOwner = null;
        this.defaultparam.start = 1;
        this.onLoadData();
    }

    private onOpenPlayer(playerURL: string) {
        // this.isPlayer = true;
        // this.playerURL = playerURL;
        window.open(playerURL, '__blank');
    }

    // -------------------------------------------------------------------
    // Methods

    private onLoadData() {
        let filterParams = copy(this.params);
        this.isLoaded = true;
        filterParams = this.parseFilter(filterParams);
        const activeTabs = this.catalogMenus.find((item: any) => item.isActive);
        if (activeTabs.key !== 'summary') {
            this.$store.dispatch(`activityStore/${this.activeComponent.apiKey}CatalogSearch`,  filterParams).then(
                (contents) => {
                    this.pageContents = this.pageContents.concat(contents);
                    this.pageContents = [...new Set(this.pageContents.map((s: any) => JSON.stringify(s)))]
                        .map((s: any) => JSON.parse(s));
                    this.isLoaded = false;
                    this.isLoading = false;
                });
        }
    }


    private contentBind(content: any) {
        const contentBind: any = {};
        contentBind.isMyContent = this.isMyContent;
        contentBind[this.activeComponent.key] = content;
        if (this.activeComponent.key === 'partnerContent') {
            contentBind.isActivityContent  = true;
        }
        return contentBind;
    }

    private loadMore() {
        this.defaultparam.start = this.defaultparam.start + 1;
        this.onLoadData();
    }

    private parseFilter(filterParams: any) {
        if (this.subFilter) {
            filterParams = Object.assign({}, this.subFilter , filterParams);
        }
        if (this.isOwnerFilter) {
            filterParams['flt.creatorId'] = this.activeOwner.id;
        }
        if (this.libraryFilter && this.filterParams.scopeKey === 'open-library') {
            filterParams =  Object.assign({}, this.libraryFilter , filterParams);
        }
        return filterParams;
    }
}
